/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyNormalInput } from "../../dynamicComponent/myInputs";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../../axiosComponent/create";
import MandatoryMark from "../../common/mandatorymark";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
// import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../../dynamicComponent/datepick";
import { translate } from "react-i18next";
import moment from "moment";

const ModalBroadcast = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [VendorsGroup, setVendorsGroup] = useState([]);
  var vendorIndex = 0;

  useEffect(() => {
    getAllVendors();
  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
    // if (values.vendor) handleSubmit();
  };

  const handleSubmited = () => {
    if (values.pull_rates == 1 && values.base_rate && values.uom) {
      if (values.allVendors.length > 0) {
        handleSubmit();
        setmodalOpen(false);
      }
    } else if (values.pull_rates == 0) {
      if (values.allVendors.length > 0) {
        handleSubmit();
        setmodalOpen(false);
      }
    }
  };

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
        getAllVendorsGroup();
      })
      .catch((err) => setVendors([]));
  };

  const getAllVendorsGroup = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/group`,
    })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendorsGroup([])
          : setVendorsGroupState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };

  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: vendorIndex++,
      };
    });
    setVendors(result);
  };

  const checkForOrder = (name, data) => {
    setFieldValue("uom", data.value);
  };


  const setVendorsGroupState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vendorGroupName,
        key: item.vendorGroupId,
        value: vendorIndex++,
      };
    });
    setVendorsGroup(result);
  };

  const divideVendorsAndVendorGroup = (name, data) => {
    let temp = data.options.filter((ele) => {
      return ele.value == data.value[data.value.length - 1];
    })[0];
    temp.raw.transporterMasterId
      ? values.vendors.push(temp.raw.transporterMasterId)
      : values.vendor_groups.push(temp.raw.vendorGroupId);
    setFieldValue("allVendors", data.value);
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        // size="tiny"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("title_button") || "Broadcast"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("title") || "Broadcast Shipment"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
            <div className="ui form">
              <FormUi.Group widths={2}>
                <FormUi.Field>
                  <label>{t("vendors.title") || "Vendors"}{" "}<MandatoryMark /></label>
                  {/* <Fieldmik name="vendor" component={MyInput} /> */}
                  <Dropdown
                    name="allVendors"
                    clearable
                    multiple
                    search
                    style={{ width: "100%" }}
                    selection
                    placeholder={t("vendors.placeholder") || "Select Vendor"}
                    onChange={(name, data) =>
                      divideVendorsAndVendorGroup(name, data)
                    }
                    options={[...VendorsGroup, ...Vendors]}
                    defaultValue={values.vendors}
                  />
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group widths={2}>
                <FormUi.Field>
                  <label>
                    {t("start_time.title") || "Broadcast Start Date & Time"}{" "}<MandatoryMark />
                  </label>
                  <DateData
                    name="broadcast_start_datetime"
                    autoComplete="off"
                    showTimeSelect
                    timeFormat="HH:mm"
                    popperClassName="dateTime"
                    dateFormat="dd/MM/yyyy HH:mm"
                    placeholderText={
                      t("start_time.placeholder") || "Start Date"
                    }
                    timeIntervals={5}
                    customInput={
                      <Input
                        icon="time"
                        className="poupDate"
                        iconPosition="left"
                      />
                    }
                  />
                </FormUi.Field>
                <FormUi.Field>
                  <label>
                    {t("end_time.title") || "Broadcast End Date & Time"}{" "}<MandatoryMark />
                  </label>
                  <DateData
                    name="broadcast_end_datetime"
                    autoComplete="off"
                    showTimeSelect
                    timeFormat="HH:mm"
                    popperClassName="dateTime"
                    dateFormat="dd/MM/yyyy HH:mm"
                    placeholderText={t("end_time.placeholder") || "End Date"}
                    timeIntervals={5}
                    customInput={
                      <Input
                        icon="time"
                        className="poupDate"
                        iconPosition="left"
                      />
                    }
                  />
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group widths={3}>
                <FormUi.Field
                  as="label"
                  label={t("notification.title") || "Notification"}
                />
                <FormUi.Field
                  control={Checkbox}
                  name="email"
                  onChange={(name, data) =>
                    // checkPullRates(name, data),
                    data.checked
                      ?
                      setFieldValue("email", 1)
                      : setFieldValue("email", 0)
                  }
                  label={t("notification.actions.email") || "Email"}
                />
                <FormUi.Field
                  control={Checkbox}
                  name="sms"
                  onChange={(name, data) =>
                    // checkPullRates(name, data),
                    data.checked
                      ?
                      setFieldValue("sms", 1)
                      : setFieldValue("sms", 0)
                  }
                  label={t("notification.actions.sms") || "SMS"}
                />
                <FormUi.Field
                  control={Checkbox}
                  name="mobile"
                  onChange={(name, data) =>
                    // checkPullRates(name, data),
                    data.checked
                      ?
                      setFieldValue("mobile", 1)
                      : setFieldValue("mobile", 0)
                  }
                  label={
                    t(t("notification.actions.mobile_app")) || "Mobile&nbsp;App"
                  }
                />
              </FormUi.Group>
              <FormUi.Group widths={2}>
                <FormUi.Field
                  control={Checkbox}
                  name="pull_rates"
                  onChange={(name, data) =>
                    // checkPullRates(name, data),
                    data.checked
                      ?
                      setFieldValue("pull_rates", 1)
                      : (setFieldValue("pull_rates", 0), setFieldValue("uom", null), setFieldValue("base_rate", null), setFieldValue("return_load", 0))
                  }
                  label={
                    t("notification.actions.pull_rate_from_vendors") ||
                    "Pull Rate From Vendors"
                  }
                />
              </FormUi.Group>
              {values.pull_rates == 1 ? (
                <>
                  <FormUi.Group widths={3}>
                    <FormUi.Field width={3}>
                      <label className="labelName mt-2">
                        {t("base_rate.title") || "Base Rate"}{" "}<MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field
                      width={4}
                      error={touched.base_rate && errors.base_rate ? true : false}
                    >
                      <Fieldmik
                        component={MyNormalInput}
                        label={{ basic: true, content: "₹" }}
                        labelPosition="left"
                        name="base_rate"
                        type="number"
                        min={0}
                      />
                      {touched.base_rate && errors.base_rate ? (
                        <div className="w3-small w3-text-red">
                          {t(
                            `${errors.base_rate}`
                          ) || errors.base_rate}
                        </div>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field width={3}>
                      <label className="labelName mt-2">
                        {t("uom.title") || "UOM"}{" "}{" "}<MandatoryMark />
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={4}>
                      <Dropdown
                        name="uom"
                        style={{ width: "100%", fontWeight: "normal" }}
                        selection
                        value={values.uom}
                        placeholder={t("uom.placeholder") || "Unit Of Measurement"}
                        onChange={(name, data) => checkForOrder(name, data)}
                        options={[
                          { key: "1", text: "KG", value: "kg" },
                          { key: "2", text: "Ton", value: "ton" },
                          { key: "3", text: "Trip", value: "trip" },
                          { key: "4", text: "KM", value: "km" },
                        ]}
                      />
                      {touched.uom && errors.uom ? (
                        <div className="w3-small w3-text-red">
                          {t(
                            `${errors.uom}`
                          ) || errors.uom}
                        </div>
                      ) : null}
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group widths={3}>
                    <FormUi.Field
                      control={Checkbox}
                      name="return_load"
                      onChange={(name, data) =>
                        // checkPullRates(name, data),
                        data.checked
                          ?
                          setFieldValue("return_load", 1)
                          : setFieldValue("return_load", 0)
                      }
                      label={
                        t("return_load.title") ||
                        "Return Load"
                      }
                    />
                  </FormUi.Group>
                </>
              ) :
                (
                  null
                )}
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime) ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
// TODO: validation
const FormikBroadcast = withFormik({
  validationSchema: yup.object({
    pull_rates: yup.boolean().optional(),
    base_rate: yup.number().when('pull_rates', {
      is: (value) => value,
      then: yup.number().required('Required').nullable(), otherwise: yup.number().optional().nullable()
    }),
    uom: yup.string().when('pull_rates', {
      is: (value) => value,
      then: yup.string().required('Required').nullable(), otherwise: yup.string().optional().nullable()
    }),
  }),
  mapPropsToValues: (props) => {
    return {
      allVendors: [],
      vendors: [],
      vendor_groups: [],
      broadcast_start_datetime: new Date(),
      broadcast_end_datetime: moment(new Date()).add(120, 'm').toDate(),
      shipment_id: +props.shipmentId,
      pull_rates: 0,
      email: 0,
      base_rate: null,
      uom: 'trip',
      return_load: 0,
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.order.vendor_order_id}/broadcast`,
      payload: { ...values },
    })
      .then((res) => {
        setSubmitting(false);
        console.log(res);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        props.reFetchOrder();
      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        });
      });
  },
})(ModalBroadcast);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("broadcast")(FormikBroadcast)
);
